<template>
  <div class="park-empty">
    <div class="park-empty__content">
      <div class="park-empty__icon-wrap">
        <span class="mdi mdi-floor-plan park-empty__icon"></span>
        <div class="park-empty__icon-bar"></div>
      </div>

      <h3 class="park-empty__title">Tu parque aún no tiene naves registradas</h3>
      <p class="park-empty__subtitle">
        Registra las naves de tu parque para comenzar a gestionar contratos, mantenimiento y servicios.
      </p>

      <div class="park-empty__actions">
        <button class="park-empty__btn park-empty__btn--primary" @click="$emit('register-plot')">
          Registrar primera nave
        </button>
        <button class="park-empty__btn park-empty__btn--secondary" @click="$emit('import-plots')">
          Importar desde archivo
        </button>
      </div>

      <p class="park-empty__footer">
        Una vez que registres tus naves podrás asignar contratos, dar seguimiento a mantenimiento y visualizar la
        ocupación del parque.
      </p>
    </div>
  </div>
</template>

<script setup>
defineEmits(['register-plot', 'import-plots'])
</script>

<style scoped>
.park-empty {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.park-empty__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.9rem;
  max-width: 360px;
}

.park-empty__icon-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.3rem;
}

.park-empty__icon {
  font-size: 56px;
  color: #e2e8f0;
}

.park-empty__icon-bar {
  width: 80px;
  height: 8px;
  background: #f1f5f9;
  border-radius: 4px;
}

.park-empty__title {
  font-family: var(--font-body);
  font-weight: 500;
  font-size: 15px;
  color: #374151;
  margin: 0;
}

.park-empty__subtitle {
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

.park-empty__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 0.4rem;
}

.park-empty__btn {
  font-family: var(--font-body);
  font-weight: 500;
  font-size: 13px;
  border-radius: 6px;
  padding: 0.55rem 1.1rem;
  cursor: pointer;
  transition: filter 0.15s ease, background 0.15s ease;
}

.park-empty__btn--primary {
  background: #3b82f6;
  color: #ffffff;
  border: none;
}

.park-empty__btn--primary:hover {
  filter: brightness(1.05);
}

.park-empty__btn--secondary {
  background: #ffffff;
  color: var(--text-content);
  border: 1px solid #e2e8f0;
}

.park-empty__btn--secondary:hover {
  background: #f8fafc;
}

.park-empty__footer {
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 10px;
  color: #9ca3af;
  margin: 0.4rem 0 0;
  line-height: 1.4;
}
</style>